import gql from 'graphql-tag';

import postFragment from '~/shared/graphql-queries/posts/post-fragment';

export default gql`
  query findByIdPostQuery($_id: MongoID!) {
    findByIdPostQuery(_id: $_id) {
      ...PostFragment
    }
  }
  ${postFragment}
`;
